import React from 'react';
import { RouteObject } from 'react-router-dom';
import MainLayout from '../layouts/MainLayout';
import Dashboard from '../pages/Dashboard';
import { CompaniesList, AddCompany, EditCompany, CompanyDetails, AddProject, AddPlan, CandidatesListing, JobSeekerPlan, Module, Emails } from '../pages/Companies';
import ProjectDetails from '../pages/Companies/ProjectDetails';
import Plans from '../pages/Plans';
import LeadList from '../pages/Companies/LeadList/LeadList';
import Permissions from '../pages/Permissions';
import Candidates from '../pages/Candidates';
import CandidateDetail from '../pages/Candidates/CandidateDetail';
import Login from '../pages/Auth/Login';
import NotFound from '../pages/NotFound';
import AuthRoute from './AuthRoute';
import Prompts from '../pages/Companies/JobSeekers/Prompts/Prompts';
import Transcription from '../pages/Companies/JobSeekers/Transcription/Transcription';
import PaymentHistory from '../pages/Companies/JobSeekers/PaymentHistory/PaymentHistory';
import Visitors from '../pages/Companies/JobSeekers/Visitors/Visitors';
import LegalContent from '../pages/CMS/LegalContent';
import HomeVideo from '../pages/CMS/HomeVideo';
import MasterEmail from '../pages/MasterEmail/MasterEmail';
import DefaultPrompts from '../pages/DefaultPrompts';

const routes: RouteObject[] = [
  {
    path: '/login',
    element: <Login />,
  },
  {
    path: '/',
    element: <AuthRoute element={<MainLayout />} />,
    children: [
      {
        index: true,
        element: <Dashboard />,
      },
      {
        path: 'companies',
        element: <CompaniesList />,
      },
      {
        path: 'companies/add',
        element: <AddCompany />,
      },
      {
        path: 'companies/edit/:id',
        element: <EditCompany />,
      },
      {
        path: 'companies/:id',
        element: <CompanyDetails />,
      },
      {
        path: 'companies/:id/projects/new',
        element: <AddProject />,
      },
      {
        path: 'companies/:id/projects/:projectId',
        element: <ProjectDetails />,
      },
      {
        path: 'companies/:id/plans/new',
        element: <AddPlan />,
      },
      {
        path: 'plans',
        element: <Plans />,
      },
      {
        path: 'emails',
        element: <Emails type={'is_hiring_manager'} />,
      },
      {
        path: 'master-emails',
        element: <MasterEmail />,
      },
      {
        path: 'lead-list',
        element: <LeadList />,
      },
      {
        path: 'prompts',
        element: <DefaultPrompts />,
      },
      {
        path: 'permissions',
        element: <Permissions />,
      },
      {
        path: 'candidates',
        element: <Candidates />,
      },
      {
        path: 'candidates/:id',
        element: <CandidateDetail />,
      },

      {
        path: 'jobseekers/visitors',
        element: <Visitors />,
      },

      {
        path: 'jobseekers/candidates',
        element: <CandidatesListing />,
      },

      {
        path: 'jobseekers/transcription',
        element: <Transcription />,
      },

      {
        path: 'jobseekers/payments',
        element: <PaymentHistory />,
      },

      {
        path: 'jobseekers/plans',
        element: <JobSeekerPlan />,
      },
      {
        path: 'jobseekers/emails',
        element: <Emails type={'is_job_hunter'} />,
      },
      {
        path: 'jobseekers/prompts',
        element: <Prompts />,
      },
      {
        path: 'jobseekers/Module',
        element: <Module />,
      },
      {
        path: 'cms/legal',
        element: <LegalContent />,
      },
      {
        path: 'cms/home-video',
        element: <HomeVideo />,
      },
    ],
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;